// src/extenders/predictive-search.js
var PredictiveSearch = class extends HTMLElement {
  constructor() {
    super();
    this.trigger = document.getElementById(this.getAttribute("aria-controlledby"));
    this.closeButtons = this.querySelectorAll("[data-close]");
    this.input = this.querySelector('[name="q"]');
    this.megaMenu = document.querySelector("mega-menu");
    this.searchContentWrapper = this.querySelector(".predictive-search-content-wrapper");
    this.searchShadow = this.querySelector(".predictive-search-shadow");
    this.popularPills = [];
    this.debounceTimer = null;
    this.debounceDuration = parseInt(this.getAttribute("data-debounce-duration") || 300);
    if (this.trigger === null) {
      return;
    }
    this.trigger.addEventListener("click", (e) => this._toggleSearch(e));
    for (const closeButton of this.closeButtons) {
      closeButton.addEventListener("click", (e) => this._toggleSearch(e));
    }
    if (this.input) {
      this.input.addEventListener("input", this._search.bind(this));
    }
    this._attachContentListeners();
  }
  _applyPopularSearch(text) {
    this.input.value = text;
    this.input.dispatchEvent(new Event("input"));
  }
  _toggleSearch(e) {
    e.preventDefault();
    if (this.hasAttribute("open")) {
      this._closeSearch();
    } else {
      if (this.megaMenu) {
        this.megaMenu.hideAllMegaMenu();
      }
      this.setAttribute("open", "");
      this.setAttribute("aria-hidden", "false");
      this.dispatchEvent(new CustomEvent("search:open"));
      document.documentElement.classList.add("overflow-hidden");
    }
  }
  _closeSearch() {
    if (!this.hasAttribute("open")) {
      return;
    }
    this.removeAttribute("open");
    this.setAttribute("aria-hidden", "true");
    this.dispatchEvent(new CustomEvent("search:close"));
    document.documentElement.classList.remove("overflow-hidden");
  }
  _search() {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this._updateResults();
    }, this.debounceDuration);
  }
  _updateResults() {
    const searchTerm = this.input.value.trim();
    let url = `/search/suggest?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`;
    if (searchTerm === "") {
      url = "/?section_id=predictive-search";
    }
    fetch(url).then((response) => response.text()).then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector(".predictive-search-content-wrapper").innerHTML;
      this.searchContentWrapper.innerHTML = resultsMarkup;
      this._attachContentListeners();
    });
  }
  _attachContentListeners() {
    this.popularPills = this.querySelectorAll(".search-term");
    for (const pill of this.popularPills) {
      pill.addEventListener("click", () => this._applyPopularSearch(pill.dataset.term));
    }
  }
};
if (!window.customElements.get("predictive-search")) {
  window.customElements.define("predictive-search", PredictiveSearch);
}
